import styled from 'styled-components'

import { IndexLayoutOldSubtitle } from '@sketch/modules-common'
import { Text } from '@sketch/components'

export const Wrapper = styled.div`
  height: 100%;
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const VerificationCodeContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 40px;
`

export const LinkDescription = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.C',
})``

export const Subtitle = styled(IndexLayoutOldSubtitle)`
  max-width: 400px;
  margin: 8px auto 0;
`
